import { useSelector } from 'react-redux'
import { userPreferencesView } from '$logic/user-preferences/storage'

export function usePinnedRoomIds() {
  return useSelector(state => userPreferencesView(state)?.pinnedRooms) || []
}
